var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFormatClear(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Huge-icon/editor/outline/format-clear"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2642",
    d: "M5 5L19 19",
    stroke: "#28303F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5796 9.64026L9.25763 18.894C9.19905 19.3041 9.48398 19.684 9.89403 19.7426C10.3041 19.8011 10.684 19.5162 10.7426 19.1062L11.9054 10.9661L10.5796 9.64026ZM12.1706 9.10993L12.7426 5.10616C12.8011 4.69611 12.5162 4.31621 12.1062 4.25763C11.6961 4.19905 11.3162 4.48398 11.2576 4.89403L10.8448 7.78411L12.1706 9.10993Z",
    fill: "#28303F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4402 4.50086C5.3219 4.63345 5.25 4.80833 5.25 5C5.25 5.41421 5.58579 5.75 6 5.75H6.68934L5.4402 4.50086ZM8.81066 5.75H18C18.4142 5.75 18.75 5.41421 18.75 5C18.75 4.58579 18.4142 4.25 18 4.25H7.31066L8.81066 5.75Z",
    fill: "#28303F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatClear);
export default __webpack_public_path__ + "static/media/format-clear.3cfdb318461f5200d7d2fd58999a8bc6.svg";
export { ForwardRef as ReactComponent };